<template>
  <v-container class="pt-6">
    <v-card class="elevation-12 mb-6">
      <v-card-title class="px-9 pt-7">
        Nahlášení odečtu
      </v-card-title>

      <SearchEAN
        :searchEanLoading="collectionPointLoading"
        @installationLoading="collectionPointLoading = $event"
      />
    </v-card>

    <v-card class="elevation-12">
      <v-card-title class="px-9 pt-7">
        Hromadný odečet
      </v-card-title>

      <v-card-text class="px-9">
        <ValidationObserver ref="bulkReadingForm" v-slot="{ invalid, passes }">
          <v-form rel="bulkReadingForm" @submit.prevent="passes(save)">
            <v-row>
              <v-col cols="4">
                <VFileInputWithValidation
                  v-model="file"
                  :rules="{
                    required: true,
                    ext: ['xlsx'],
                  }"
                  dense
                  prepend-icon=""
                  append-icon="$file"
                  @click:append="
                    $event.target.offsetParent.querySelector(`[class='v-file-input__text']`).click()
                  "
                  :clearable="false"
                  outlined
                  label="Nahrajte soubor .XLSX"
                  accept=".xlsx"
                  @change="fileUpload($event)"
                />
              </v-col>

              <v-col>
                <v-btn
                  depressed
                  type="submit"
                  height="40px"
                  min-width="125px"
                  color="primary"
                  :loading="loading"
                >
                  Odeslat
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>

        <v-row>
          <v-col class="mx-3" style="background-color: rgb(223, 237, 214);">
            <v-row>
              <v-col
                cols="12"
                class="d-inline-flex align-center justify-center px-1"
              >
                <h2>
                  Vzor
                </h2>
              </v-col>

              <v-col class="d-inline-flex align-center justify-center px-1">
                <a
                  href="odecty-vzor.xlsx"
                  @click.prevent="fileDownload($event)"
                >
                  Vzor .xlsx souboru pro odevzdání hromadného odečtu
                </a>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="mx-3" style="background-color: rgb(223, 237, 214);">
            <v-row>
              <v-col
                cols="12"
                class="d-inline-flex align-center justify-center px-1"
              >
                <h2>
                  Nápověda
                </h2>
              </v-col>

              <v-col
                cols="12"
                class="d-inline-flex align-center justify-center px-1 text-center"
              >
                Nahlášení odečtu je možné jen pro odběrná místa typu měření C.
                <br />
                Kontrolní odečet je možné zadat max. 30 kalendářních dnů od jeho provedení
                a max. 10x za rok.
                <br />
                Odečet k Mimořádná faktura - odečet na konci roku je možné zadat pouze k datu
                31. 12. v období od 31. 12. do 30. 1. následujícího roku.
                <br />
                Odečet k mimořádné fakturaci lze zadat 4x za fakturační období vyjma 31.12.
                <br />
                Odečet ke změně dodavatele musí splňovat podmínku do 5 pracovních dnů
                od data zahájení dodávky.
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <BulkInstallationDialog v-model="bulkInstallationDialogData" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import SearchEAN from '@/components/utils/SearchEAN.vue';
import BulkInstallationDialog from '@/components/dialogs/BulkInstallationDialog.vue';
import { downloadFile } from '@/components/mixins/downloadFile';
import { checkAuth } from '@/components/mixins/checkAuth';

export default {
  name: 'ReportReading',
  components: {
    SearchEAN,
    BulkInstallationDialog,
  },
  mixins: [downloadFile, checkAuth],
  data() {
    return {
      file: null,
      bulkInstallationDialogData: {
        show: false,
        data: {},
        fileDownloadLoading: false,
      },
      loading: false,
      collectionPointLoading: false,
    };
  },
  methods: {
    ...mapActions({
      createNewBulkReadingRequest: 'requests/createNewBulkReadingRequest',
    }),
    save() {
      this.loading = true;
      this.createNewBulkReadingRequest(this.file)
        .then((response) => {
          if (response.status === 200) {
            this.bulkInstallationDialogData.data = response.data;
            this.bulkInstallationDialogData.show = true;
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.bulkInstallationDialogData.fileDownloadLoading = false;
            this.bulkInstallationDialogData.data = error.response.data;
            this.bulkInstallationDialogData.show = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.file = null;
          this.$refs.bulkReadingForm.reset();
        });
    },
    fileUpload(event) {
      this.file = event;
    },
    fileDownload(event) {
      this.downloadFile(event, 'requests/BULK_READING/template');
    },
  },
};
</script>
